<script>
import { mapState } from 'vuex'
export default {
  name: 'Footer',
  computed: {
    ...mapState(['selectedPractice'])
  }
}
</script>

<template>
<v-footer id="footer" class="pt-6 pb-0">
  <v-container class="">
    <v-row justify="center">
      <v-col class="logo pl-0" sm="5" cols="12">
        <v-img contain max-width="221" src="@/assets/img/pathways_logo.png" />
      </v-col>
      <v-col class="clinic pr-0" sm="5" cols="12">
        <h2 class="practice-title">{{ selectedPractice.name }}</h2>
        <div class="address mt-4">
          <p>{{ selectedPractice.address.street }}</p>
          <p>{{ selectedPractice.address.city }}, {{ selectedPractice.address.state }} {{ selectedPractice.address.zip }}</p>
          <p>{{ selectedPractice.phone }}</p>
        </div>
      </v-col>
    </v-row>
    <v-row justify="center">
      <v-col class="bottomlinks mt-6" sm="10" cols="12">

          <span>Copyright 2021 Pathway</span>
          <span class="link" @click="$router.push({ name: 'PrivacyPolicy' })">Privacy Policy</span>
          <span class="link" @click="$router.push({ name: 'TermsAndConditions' })">Terms and Conditions</span>
          <span class="link" @click="$router.push({ name: 'TermsOfUse' })">Terms of Use</span>

      </v-col>
    </v-row>
    <v-row justify="center">
      <v-col style="border: none;" class="bottomlinks mt-6" sm="10" cols="12">
        <span style="font-style: italic;" class="text-caption">1. Wellness, Wellness Bi-Annual, Brief, Emergency, Emergency-Recheck, Illness, Nurse, Recheck exams are included in the program.</span>
      </v-col>
    </v-row>
  </v-container>
</v-footer>
</template>

<style lang="scss" scoped>
#footer {
  background-color: $hpp-blue;
  color: white;
  border-top: solid 1px white;
}
.logo {
  text-align: left;
}
.clinic {
  text-align: right;
}
.practice-title {
  font-size: 18px;
  line-height: 12px;
  font-weight: 600;
}
.address {
  line-height: 0;
  font-size: 13px;
}
.bottomlinks {
  border-top: solid 1px white;
  font-size: 11px;
}
.bottomlinks span {
  margin-right: 5%;
}
.bottomlinks .link {
  cursor: pointer;
}
.bottomlinks .link:hover {
  text-decoration: underline;
}
@media only screen and (max-width: 600px) {
  .clinic {
    text-align: left;
  }
}
</style>
